import { Validator } from '@vista-digital/validator';
/*
 * Positioning options for the Seat Picker component's legend.
 */
export var SeatPickerLegendPosition;
(function (SeatPickerLegendPosition) {
    SeatPickerLegendPosition["Top"] = "Top";
    SeatPickerLegendPosition["Bottom"] = "Bottom";
})(SeatPickerLegendPosition || (SeatPickerLegendPosition = {}));
export const seatPickerLegendPositionValidator = Validator.oneOf(Object.values(SeatPickerLegendPosition));
